import { render, staticRenderFns } from "./cart-flex.vue?vue&type=template&id=5f20f20b&scoped=true&"
var script = {}
import style0 from "./cart-flex.vue?vue&type=style&index=0&id=5f20f20b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20f20b",
  null
  
)

export default component.exports